import { ConvertToJSONService } from './convert-to-json.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { ConfigService } from '../config.service';
const headers = {
  headers: new HttpHeaders({ 'content-type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class UserTrackingService {
  ServerUrl = this.serverConfig.ServerUrl;
  User_Type: any = 0;
  UserId: any;
  constructor(
    private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private ConvertToJSON: ConvertToJSONService,
    private serverConfig :ConfigService
  ) {}

  GenerateToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    //this.UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    try {
      this.User_Type = this.EncrdecrService.getDecr(
        sessionStorage.getItem('L2D3506kIHSk3E0')
      );
      if (this.User_Type == '3') {
        this.UserId = this.EncrdecrService.getDecr(
          sessionStorage.getItem('UZT6qHaDZSz66kx')
        );
      } else {
        this.UserId = this.EncrdecrService.getDecr(
          sessionStorage.getItem('F44sGAGh2xwkpUL')
        );
      }

      var s = this.EncrdecrService.getDecr(
        sessionStorage.getItem('N1QJHdOkO7Hz8QC')
      );
    } catch (e) {}
    //this.User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + this.UserId + '|' + this.User_Type + '|' + IpAddress
    );
    const GeneratedToken = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    return GeneratedToken;
  }

  SaveEvent(EventName: string) {
    const tokenOption = this.GenerateToken();

    let url = `${this.ServerUrl}/api/UserTrackingLog/SaveEvent`;
    let DataBody = {
      UserType: this.User_Type,
      UserID: this.UserId,
      EventName: EventName
    };
    return this.http.post<any[]>(url, DataBody, tokenOption).pipe();
  }

  UpdateTransactionStatus(UserLogId: number) {
    let url = `${this.ServerUrl}/api/UserTrackingLog/UpdateTransactionStatus`;
    const tokenOption = this.GenerateToken();
    let DataBody = {
      UserLogId: UserLogId,
      TransactionStatus: 'success'
    };
    return this.http.post<any[]>(url, DataBody, tokenOption).pipe();
  }

  GetUsersData(
    uid: string,
    utype: string,
    FromDate: string,
    ToDate: string,
    Flag: string = '',
    Page: string = '',
    Status: string = '',
    Updateflag: string = ''
  ) {
    let url = `${this.ServerUrl}/api/UserTrackingLog/UserTrackingData`;
    const tokenOption = this.GenerateToken();
    let DataBody = {
      UserID: uid,
      UserType: utype,
      FromDate: FromDate,
      ToDate: ToDate,
      Flag: Flag,
      Page: Page,
      Status: Status,
      ViewFlag: Updateflag,
      CallUserId: this.UserId
    };
    return this.http.post<any[]>(url, DataBody, tokenOption).pipe();
  }

  GetServiceFlag(uid: string, utype: string) {
    let url = `${this.ServerUrl}/api/UserTrackingLog/GETServiceflag`;
    const tokenOption = this.GenerateToken();
    let DataBody = {
      UserID: uid,
      UserType: utype
    };
    return this.http.post<any[]>(url, DataBody, tokenOption).pipe();
  }
  GetDropDownData(TransType: string) {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=${TransType}&REFF_ID=&CON_STR=SMC_CLOUD&REFF_ID2=&REFF_ID3=`;
    let body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    let tokenOption = this.GetToken();
    return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  GetToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log(token + '@' + UserId + '|' + User_Type + '|' + IpAddress);
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    return tokenOption;
  }
}
